import { ReactNode } from 'react';
import { AnswerButtonVariant, VisualAsset } from 'core/flow/entities';
import { getVisualAssetImageSrc } from '../VisualAssetImage';
import { ButtonImage } from './ButtonImage';
import { ButtonOption } from './ButtonOption';

type AnswerButtonProps = {
  image?: VisualAsset;
  onClick: () => void;
  children?: ReactNode;
  variant?: AnswerButtonVariant;
};

export const AnswerButton = ({
  children,
  onClick,
  image,
  variant = AnswerButtonVariant.OPTION,
  ...otherProps
}: AnswerButtonProps) => {
  if (variant === AnswerButtonVariant.IMAGE) {
    return (
      <ButtonImage onClick={onClick} srcImage={getVisualAssetImageSrc(image)} {...otherProps}>
        {children}
      </ButtonImage>
    );
  }

  return (
    <ButtonOption onClick={onClick} image={image} {...otherProps}>
      {children}
    </ButtonOption>
  );
};
